export var generateUniqueEmail = function (email, identifier) {
    var _a = email.split('@'), first = _a[0], second = _a[1];
    return "".concat(first, "+").concat(identifier, "@").concat(second);
};
